(function () {
  var discountCode = 'B1G2';
  var requiredGiftCount = 2;
  var removalStorageKey = 'ns_b1g2_popup_dismissed_at';
  var cartState = null;
  var handling = false;

  function rememberPromotionRemoval() {
    try {
      sessionStorage.setItem(removalStorageKey, String(Date.now()));
    } catch (error) {}
  }

  function routesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function requestJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (!response.ok) throw new Error(payload.description || payload.message || 'Le panier n’a pas pu être mis à jour.');
        return payload;
      });
    });
  }

  function property(item, name) {
    return item && item.properties ? item.properties[name] : null;
  }

  function groupBundles(cart) {
    var bundles = {};
    (cart.items || []).forEach(function (item) {
      var token = property(item, '_B1G2 bundle');
      if (!token) return;
      if (!bundles[token]) bundles[token] = [];
      bundles[token].push(item);
    });
    return bundles;
  }

  function isValidBundle(items) {
    var offers = items.filter(function (item) { return property(item, '_B1G2 offer') === 'true'; });
    var gifts = items.filter(function (item) { return property(item, '_B1G2 gift') === 'true'; });
    return offers.length === 1 && offers[0].quantity >= 1 && gifts.length === requiredGiftCount && gifts.every(function (item) {
      return item.quantity === 1;
    });
  }

  function hasValidBundle(cart) {
    var bundles = groupBundles(cart);
    return Object.keys(bundles).some(function (token) {
      return isValidBundle(bundles[token]);
    });
  }

  function remainingDiscountCodes(cart) {
    return (cart.discount_codes || [])
      .map(function (discount) { return discount.code; })
      .filter(function (code) { return code && String(code).toUpperCase() !== discountCode; });
  }

  function hasB1G2Code(cart) {
    return (cart.discount_codes || []).some(function (discount) {
      return String(discount.code || '').toUpperCase() === discountCode;
    });
  }

  function removeUnusedB1G2(cart) {
    if (hasValidBundle(cart) || !hasB1G2Code(cart)) return Promise.resolve({ cart: cart, changed: false });
    return requestJson(routesRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: remainingDiscountCodes(cart).join(',') })
    }).then(function (updatedCart) { return { cart: updatedCart, changed: true }; });
  }

  function updateCart(payload) {
    return requestJson(routesRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function removeOrphanGifts(cart) {
    var bundles = groupBundles(cart);
    var updates = {};
    Object.keys(bundles).forEach(function (token) {
      var items = bundles[token];
      var hasOffer = items.some(function (item) { return property(item, '_B1G2 offer') === 'true'; });
      if (hasOffer) return;
      items.forEach(function (item) {
        if (property(item, '_B1G2 gift') === 'true') updates[item.key] = 0;
      });
    });
    if (!Object.keys(updates).length) return Promise.resolve({ cart: cart, changed: false });
    return updateCart({ updates: updates }).then(function (updatedCart) {
      return { cart: updatedCart, changed: true };
    });
  }

  function cleanupCart(cart) {
    return removeOrphanGifts(cart)
      .then(function (orphanResult) {
        return removeUnusedB1G2(orphanResult.cart).then(function (discountResult) {
          return { cart: discountResult.cart, changed: orphanResult.changed || discountResult.changed };
        });
      })
      .then(function (result) {
        cartState = result.cart;
        return result.changed;
      });
  }

  function loadCart() {
    return requestJson(routesRoot() + 'cart.js').then(function (cart) {
      cartState = cart;
      return cart;
    });
  }

  function findCartItem(url) {
    var items = cartState && cartState.items || [];
    var key = url.searchParams.get('id');
    if (key) {
      var keyedItem = items.find(function (item) { return item.key === key; });
      if (keyedItem) return keyedItem;
    }
    var line = Number(url.searchParams.get('line') || 0);
    return line > 0 ? items[line - 1] : null;
  }

  function removePromotionItem(clickedItem) {
    var clickedToken = property(clickedItem, '_B1G2 bundle');
    var removeAffectedBundle = property(clickedItem, '_B1G2 offer') === 'true';
    var updates = {};
    (cartState.items || []).forEach(function (item) {
      if (item.key === clickedItem.key || (removeAffectedBundle && property(item, '_B1G2 bundle') === clickedToken)) {
        updates[item.key] = 0;
      }
    });

    var remainingCart = {
      items: (cartState.items || []).filter(function (item) {
        return !Object.prototype.hasOwnProperty.call(updates, item.key);
      }),
      discount_codes: cartState.discount_codes || []
    };
    var payload = { updates: updates };
    if (!hasValidBundle(remainingCart) && hasB1G2Code(cartState)) {
      payload.discount = remainingDiscountCodes(cartState).join(',');
    }

    return updateCart(payload).then(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (event) {
    if (handling || !cartState) return;
    if (!event.target || typeof event.target.closest !== 'function') return;
    var link = event.target.closest('a[href*="/cart/change"]');
    if (!link) return;
    var url = new URL(link.href, window.location.href);
    if (url.searchParams.get('quantity') !== '0') return;
    var item = findCartItem(url);
    if (!item || !property(item, '_B1G2 bundle')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    handling = true;
    rememberPromotionRemoval();
    removePromotionItem(item).catch(function () { window.location.assign(link.href); });
  }, true);

  loadCart()
    .then(cleanupCart)
    .then(function (changed) {
      if (changed) window.location.reload();
    })
    .catch(function () {});
})();
